import { Row, Col } from "react-bootstrap";
import styles from "./AboutArcade.module.css";

function AboutArcadeProposal() {
  return (
    <Row className={styles.ContentContainer}>
      <Col className="d-flex align-items-center">
        <div>
          <div className={styles.makeProposalTitle}>About this Proposal</div>
          <div className={styles.makeProposalSubtext}>
            The online world lacks intimacy, we're solving this using gaming. We
            found that gamers use YouTube, TikTok, and Twitch to watch their
            favourite influencers play video games. ArcadeQuest is used for
            playing with the influencers. We just closed a deal with Wondr
            Gaming and have the top gamers on Twitch who are going to use
            ArcadeQuest. Some include Mongraal (FazeClan Member 5.1M Followers),
            Chica (2.1M Followers), and Sommerset (1.2M Followers). Our team of
            decorated entrepeneurs and developer set up ArcadeQuest for success.
            Two of our Directors, Ali Jelveh and Marco Buhlman, and graduates
            from Y Combinator.
            <br /><br />
            Marco has had four previous exits in the consumer and B2B sector.
            Our lead UX Advisor, Felix Lai lead the UX team at EA Sports
            designing FIFA 16, 17, 18, and 19 before moving to Kabam games.
            Felix was the youngest UX Design leader at EA Sports. With
            ArcadeQuest, fans can play with their favourite streamers by paying
            an entry fee to get into the match.
            <br /><br />
            Each time a match is created,
            the influencer sets the entry fee and shares the match on Twitch.
            The fans then sign up on ArcadeQuest and pay the entry fee to play.
            Then their ArcadeQuest account is linked with Fortnite and they’re
            able to play with their favourite influencer on any device! The top
            three players of the match then win ArcadeQuest coins that they can
            redeem for prizes. Prizes include things like Amazon Gift Cards,
            Fortnite VBucks, Apple Gift cards and more! ArcadeQuest is at a
            major inflection point.
            <br /><br />
            After signing on some the biggest influencers on Twitch, including a
            member of FazeClan we’ve become the market leaders in community
            gameplay. We’re to further build the community around ArcadeQuest
            and with your support expand our platform to millions of influencers
            across all platforms!
          </div>
          <br /><br />
        </div>
      </Col>
    </Row>
  );
}

export default AboutArcadeProposal;

